import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { signoutRedirectCallback } from '../../services/userService';
import { AuthContext } from '../../utils/authProvider';

function SignoutOidc() {
    const navigate = useNavigate()
    const userManager = useContext(AuthContext);

    useEffect(() => {
        async function signoutAsync() {
            await signoutRedirectCallback(userManager);
            navigate('/');
        }

        signoutAsync();
    }, [navigate]);

    return (
        <div>
            Redirecting...
        </div>
    )
}

export default SignoutOidc
